import { render, staticRenderFns } from "./chat-session-list.vue?vue&type=template&id=4918887c"
import script from "./chat-session-list.vue?vue&type=script&lang=js"
export * from "./chat-session-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports